import { isNaN } from 'lodash-es';
import { isEmptyOrUndefined } from '../../../utils/common/validators';

const numberRejex = /\D/g;

function convertToNumber(val) {
	return val.replace(numberRejex, '');
}

function validateDecimalInputs(val, afterDecimal) {
	if (isEmptyOrUndefined(val)) {
		return '';
	}
	const beforeDecimal = 9;

	const value = val
		.replace(/[^\d.]/g, '')
		.replace(new RegExp(`(^[\\d]{${beforeDecimal}})[\\d]`, 'g'), '$1')
		.replace(/(\..*)\./g, '$1')
		.replace(new RegExp(`(\\.[\\d]{${afterDecimal}}).`, 'g'), '$1');

	return value;
}

function convertPaisaToRupees(value, divider = 0, supportedDecimalPlaces = 2) {
	if (value.toString() === '0' || divider.toString() === '0') return value;
	const val = value / divider;

	if (isNaN(val) || isEmptyOrUndefined(val)) {
		return 0;
	} else {
		return val.toFixed(supportedDecimalPlaces);
	}
}

function convertRupeesToPaisa(value, divider = 100) {
	if (value === 0) return value;
	return parseFloat(value) * parseInt(divider, 10);
}

const numberValidityService = {
	convertToNumber,
	validateDecimalInputs,
	convertPaisaToRupees,
	convertRupeesToPaisa,
};

export default numberValidityService;
